import { ChipsCellComponent } from './chips-cell.component';
import type { TableColumnConfig } from '../../../data/table-column-config';
import type { ChipsCellParameters } from './chips-cell-parameters';

export function createChipsColumn<
  T,
  FIELD_VALUE_TYPE,
  FIELD_VALUE_ID_KEY extends keyof FIELD_VALUE_TYPE,
  FIELD_VALUE_ID_KEY_TYPE = FIELD_VALUE_TYPE[FIELD_VALUE_ID_KEY],
>(
  fieldId: string,
  fieldName: keyof T,
  labelI18nKey: string,
  cellParameters: ChipsCellParameters<
    FIELD_VALUE_TYPE,
    FIELD_VALUE_ID_KEY,
    FIELD_VALUE_ID_KEY_TYPE
  >,
  sortable = false,
): TableColumnConfig<T> {
  return {
    id: fieldId,
    field: fieldName,
    label: labelI18nKey,
    cellContent: ChipsCellComponent,
    cellCustomContent: (): ChipsCellParameters<
      FIELD_VALUE_TYPE,
      FIELD_VALUE_ID_KEY,
      FIELD_VALUE_ID_KEY_TYPE
    > => cellParameters,
    sortable,
  };
}
